namespace RedBullMOBILE360.CVM {
    export interface CvmCampaignRow {
        Id?: number;
        Name?: string;
        Duration?: number;
        NextRun?: string;
    }

    export namespace CvmCampaignRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'CVM.CvmCampaign';
        export const lookupKey = 'CVM.CvmCampaign';

        export function getLookup(): Q.Lookup<CvmCampaignRow> {
            return Q.getLookup<CvmCampaignRow>('CVM.CvmCampaign');
        }
        export const deletePermission = 'CVM:CvmCampaign';
        export const insertPermission = 'CVM:CvmCampaign';
        export const readPermission = 'CVM:CvmCampaign';
        export const updatePermission = 'CVM:CvmCampaign';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Duration = "Duration",
            NextRun = "NextRun"
        }
    }
}
